var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0432C",
    d: "m3.596 4.255 3.5 3.5A7.55 7.55 0 0 1 17.907 7.7L21.404 4.2C16.544-.702 8.632-.737 3.73 4.122l-.13.131z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF00",
    d: "m3.641 21.818 3.497-3.496a7.55 7.55 0 0 1 .04-10.676l.014-.013-3.499-3.499c-4.899 4.863-4.928 12.776-.065 17.675l.011.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24AA49",
    d: "M14.998 15.475v.052h.052zM12.498 25.5a12.46 12.46 0 0 0 8.851-3.674l-3.499-3.5a7.547 7.547 0 0 1-10.672.032l-.032-.032-3.496 3.496a12.46 12.46 0 0 0 8.848 3.678"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3384FC",
    d: "m24.808 10.553-9.758.013v4.96h4.617a7.6 7.6 0 0 1-1.812 2.847l3.499 3.5a12.51 12.51 0 0 0 3.454-11.32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h25.049v25H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.de5a1d144ef1b128547c6785e2e1e8bc.svg";
export { ForwardRef as ReactComponent };